export default __webpack_public_path__ + "static/media/allstars.6b35c114.png";